import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions/gbp.actions';
import { GBPModel } from '../../models/gbp.model';
export const featureKey = 'gbp_dash';

export interface GBPState {
  data: GBPModel | any;
  loaded: {
    success: boolean | any,
    after: string | any,
    data?: any
  }
  hasError: boolean;
  loading: boolean;
  error: any;
  success: any;
};

export const initialState: GBPState = {
  data: null,
  loaded: {
    success: false,
    after: '',
    data: ''
  },
  hasError: false,
  loading: false,
  error: null,
  success: false
};

const gbpReducer = createReducer(initialState,

  on(fromActions.loadGBPBegin, state => ({ ...state, loading: true })),

  on(fromActions.loadGBPSuccess, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: true,
      after: 'GBP_LOADED'
    },
    hasError: false,
    data: payload,
    success: true
  })),

  on(fromActions.loadGBPError, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: {
      success: false,
      after: 'GBP_LOADED'
    },
    hasError: true,
    error: payload,
    success: false
  })),

);

export const GBPReducer = (state: GBPState | undefined, action: Action) =>
  gbpReducer(state, action);

export const isLoading = (state: GBPState) => state.loading;
export const succeeded = (state: GBPState) => state.success;
export const hasError = (state: GBPState) => state.hasError;
export const errorMessage = (state: GBPState) => state.error;
export const gbpData = (state: GBPState) => state.data;
